<template>
  <div>
    <div class="job-notfound-main-container">
      <div class="job-notfound-white-contaniner">
        <div class="job-notfound-background-image-pos">
          <img
            width="100%"
            src="../../assets/img/pagenotfound/RestricatedBackgroundImage.svg"
            alt=""
          />
        </div>
        <div class="job-notfound-first-div">
          <div class="job-notfound-blue-txt">No job available.</div>
          <div class="job-notfound-black-txt">
            we are unable to locate the job you are looking for
          </div>
          <div class="job-notfound-black-small-txt mt-5">
            Here are a few things you can try:
          </div>
          <div class="job-notfound-grey-txt mt-3">Visit our website:</div>
          <div class="job-notfound-grey-txt-2">
            Learn more about us by visiting the
            <a
              href="http://www.hire3x.com"
              class="blue-underline"
              target="_blank"
              >Hire3x</a
            >
            website.
          </div>
          <div class="grey-txt mt-3">Contact Us:</div>
          <div class="job-notfound-grey-txt-2">
            If you believe there's an issue, feel free to
            <a
              href="https://www.hire3x.com/contactus"
              class="blue-underline"
              target="_blank"
              >Contact Us</a
            >
            for assistance.
          </div>
        </div>
        <div class="job-notfound-second-div">
          <img
            width="100%"
            src="../../assets/img/pagenotfound/jobNotFound.svg"
            alt=""
          />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Job Not Found",
  data() {
    return {};
  },
};
</script>
<style>
body {
  margin: 0;
}

.job-notfound-main-container {
  background-image: url("../../assets/img/pagenotfound/lines.svg");
  background-color: #e9ecef;
  height: calc(100vh - 70px);
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  position: absolute;
  top: 70px;
}

.job-notfound-white-contaniner {
  background-color: #ffffff;
  height: 90%;
  width: 90%;
  border: Mixed solid #8c8c8c54;
  border-radius: 8px;
  box-shadow: 0px 4px 8px 0px #0000002b;
  display: flex;
  align-items: center;
  justify-content: space-around;
  position: relative;
  padding: 2.5rem;
  overflow-y: auto;
}

.job-notfound-background-image-pos {
  position: absolute;
  bottom: 0px;
  left: 0px;
  z-index: 1;
}

.job-notfound-blue-txt {
  font-family: "Montserrat", sans-serif;
  font-size: 40px;
  font-weight: 600;
  color: #20639b;
}

.job-notfound-black-txt {
  font-family: "Lato", sans-serif;
  font-size: 22px;
  font-weight: 400;
  color: #000000;
}

.job-notfound-black-small-txt {
  font-family: "Lato", sans-serif;
  font-size: 16px;
  font-weight: 400;
  color: #000000;
}

.job-notfound-grey-txt {
  font-family: "Montserrat", sans-serif;
  font-size: 15px;
  font-weight: 600;
  color: #3a3c40;
}

.job-notfound-grey-txt-2 {
  font-family: "Montserrat", sans-serif;
  font-size: 14px;
  font-weight: 400;
  color: #3a3c40;
}

.job-notfound-blue-underline {
  font-family: "Montserrat", sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #20639b;
  text-decoration: underline;
}
.job-notfound-first-div,
.job-notfound-second-div {
  z-index: 2;
}
@media only screen and (max-width: 600px) {
  .job-notfound-first-div {
    order: 1;
  }
  .job-notfound-second-div {
    order: 0;
  }
  .job-notfound-white-contaniner {
    flex-direction: column;
    padding: 1rem;
    height: 95%;
  }
}
</style>
